import { ACTIONS } from './types';
import { setFilteredEmergenciesAction } from './set-filtered-emergencies.action';

export const setSearchTextActionCreator = searchText => dispatch => {
    dispatch({
        type: ACTIONS.SET_SEARCH_TEXT,
        payload: searchText,
    });
    dispatch(setFilteredEmergenciesAction());
}
